import { render } from "./PlaceOrderRedirectComponent.vue?vue&type=template&id=d0af7de8"
import script from "./PlaceOrderRedirectComponent.vue?vue&type=script&lang=js"
export * from "./PlaceOrderRedirectComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__